// @flow
import type { EventContent } from "redux/api-types/EventContent";
import type { EventTemplate } from "redux/api-types/EventTemplate";
import type { selectOption } from "shared/constants/flowTypes";

export const parseEventContent = (
  data: Array<EventContent> = []
): {
  [string]: EventContent,
} =>
  data.reduce(
    (
      acc: { [string]: EventContent },
      item: EventContent
    ): { [string]: EventContent } => ({
      ...acc,
      [item.id]: {
        ...item,
        attributes: {
          ...item.attributes,
          maxDuration:
            item.attributes.maxDuration === 0
              ? null
              : item.attributes.maxDuration ?? null,
        },
      },
    }),
    {}
  );

export const parseEventContentOptions = (
  data: Array<EventContent> = []
): Array<selectOption> =>
  data.map((item: EventContent): selectOption => ({
    label: item.attributes.name,
    value: item.id,
  }));

export const parseTemplates = (
  data: Array<EventTemplate> = []
): {
  [string]: EventTemplate,
} =>
  data.reduce(
    (
      acc: { [string]: EventTemplate },
      item: EventTemplate
    ): { [string]: EventTemplate } => ({
      ...acc,
      [item.id]: item,
    }),
    {}
  );
